import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { WordInterface } from '@campus/dal';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ImageDictionaryService } from '../../services';

@Component({
  standalone: false,
  selector: 'campus-image-dict-slideout',
  templateUrl: './image-dict-slideout.component.html',
  providers: [],
})
export class ImageDictSlideoutComponent implements OnInit {
  //#region Inputs
  @Input() public isOpen: boolean;
  @Input() public words: WordInterface[];
  @Input() public isReadSpeakerEnabled: boolean;
  @Input() public readSpeakerConfig: { lang: string; voice: string };
  //#endregion

  //#region Outputs
  @Output() private closedEvent = new EventEmitter<void>();
  //#endregion

  //#region Properties
  private searchTerm$ = new BehaviorSubject<string>('');
  public filteredWords$: Observable<WordInterface[]>;
  //#endregion

  //#region Dependencies
  private imageDictionaryService = inject(ImageDictionaryService);
  //#endregion

  //#region Lifecycle Hooks
  ngOnInit() {
    this.setupStreams();
  }

  //#endregion

  //#region Public Methods
  public close() {
    this.isOpen = false;
  }

  public closeDone() {
    if (!this.isOpen) {
      this.closedEvent.emit();
    }
  }

  public searchTermUpdated(searchTerm: string) {
    this.searchTerm$.next(searchTerm);
  }

  public getCardId(wordId: number): string {
    return this.imageDictionaryService.getCardId(wordId);
  }

  public readText(wordId: number): void {
    this.imageDictionaryService.readText(wordId, {
      enabled: this.isReadSpeakerEnabled,
      config: this.readSpeakerConfig,
    });
  }

  //#endregion

  //#region Private Methods
  private setupStreams() {
    this.filteredWords$ = this.searchTerm$.pipe(
      map((searchTerm) => this.imageDictionaryService.filterWords(this.words, searchTerm))
    );
  }

  //#endregion
}
